import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppStateInterface } from 'app/core/app-config/state/models';
import { Observable } from 'rxjs';

import { ErgoRoleInterface } from '../models/ergo-role.model';
import { RoleInterface } from '../models/role.model';
import { LoadErgoRoles, LoadRoles } from '../state/actions/role-load.actions';

@Injectable()
export class RoleService {
  constructor(private readonly _store: Store<AppStateInterface>) {}

  public loadAllRoles(): Observable<Readonly<RoleInterface[]>> {
    this._store.dispatch(new LoadRoles());

    return this._store.select(({ roles }: AppStateInterface) => roles.roles);
  }

  public loadAllErgoRoles(): Observable<Readonly<ErgoRoleInterface[]>> {
    this._store.dispatch(new LoadErgoRoles());

    return this._store.select(({ roles }: AppStateInterface) => roles.ergoRoles);
  }
}
